export const TABS = [
    { key: 'goods', title: 'Используется в товарах', icon: 'flaticon2-layers' },
    { key: 'semi', title: 'Используется в полуфабрикатах', icon: 'flaticon2-delivery-package' },
];

export const MEASURES_RAW = {
    kg: 'кг.',
    liter: 'л.',
    pc: 'шт.',
};